import { render } from "./MainComponent.vue?vue&type=template&id=20b2e7a4&scoped=true"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"

import "./MainComponent.vue?vue&type=style&index=0&id=20b2e7a4&scoped=true&lang=css"

import exportComponent from "E:\\vue project\\urban_cosmetic_catalog\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b2e7a4"]])

export default __exports__